import { WsEvent } from '@ts-ws/enums'

import { useSubscriptionStore } from '@stores/subscription'

import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'

export const useListenEventRetryPayment = (channel: any): void => {
  const subscriptionStore = useSubscriptionStore()

  onDisciplineReady(() => {

    channel.listen(WsEvent.SubscriptionRetryFailed, async (event: any): Promise<void> => {
      const subscriptionId = subscriptionStore.getPaymentRetrySubscriptionId

      if (subscriptionId === event.subscription_id) {
        subscriptionStore.setBannerPaymentRetryProcessing(false)
        subscriptionStore.setModalRetryPaymentProcessing(false)

        subscriptionStore.setModalPaymentRetrySuccess(false)

        subscriptionStore.setRetryPaymentModal(true)
        subscriptionStore.setBannerPaymentRetry(true)
      }
    })

    channel.listen(WsEvent.SubscriptionRetrySuccessful, async (event: any): Promise<void> => {
      const subscriptionId = subscriptionStore.getPaymentRetrySubscriptionId

      if (subscriptionId === event.subscription_id) {
        subscriptionStore.setBannerPaymentRetryProcessing(false)
        subscriptionStore.setModalRetryPaymentProcessing(false)

        subscriptionStore.setRetryPaymentModal(false)
        subscriptionStore.setBannerPaymentRetry(false)

        subscriptionStore.setModalPaymentRetrySuccess(true)

        subscriptionStore.setPaymentRetryData(null)
        localStorage.removeItem('bannerPaymentRetryProcessing')
      }
    })
  })
}
